import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Sidebar } from "../../components/Sidebar";
import { useAuthUser } from "../../auth/AuthContext";
import { useUnreadCount } from "../../hooks/useUnreadCount";

const SECTION_TITLES: Record<string, string> = {
  "/dashboard/results": "Results Review",
  "/dashboard/consultations": "Consultations",
  "/dashboard/notifications": "Notifications",
};

const CONSULTATION_DETAIL_PATTERN = /^\/dashboard\/consultations\/[^/]+$/;

export function DashboardLayout() {
  const user = useAuthUser();
  const location = useLocation();
  const navigate = useNavigate();
  const { count: unreadNotifications, refresh: refreshUnread } = useUnreadCount();

  // Refresh unread badge on route change so marking notifications read takes
  // effect immediately when navigating away from /dashboard/notifications.
  useEffect(() => {
    const timer = setTimeout(refreshUnread, 500);
    return () => clearTimeout(timer);
  }, [location.pathname, refreshUnread]);

  const isDetailPage = CONSULTATION_DETAIL_PATTERN.test(location.pathname);

  const title = isDetailPage
    ? null
    : Object.entries(SECTION_TITLES).find(([path]) =>
        location.pathname.startsWith(path)
      )?.[1] ?? "Results Review";

  return (
    <div className="flex min-h-screen">
      <Sidebar email={user?.email ?? ""} unreadNotifications={unreadNotifications} />
      <main className="flex-1 bg-bg-primary">
        <div className="h-[62px] border-b border-stroke-primary bg-bg-primary flex items-center px-6 gap-2">
          {isDetailPage && (
            <button onClick={() => navigate("/dashboard/consultations")} className="shrink-0">
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
                <path d="M13.75 18.15L7.78 12.18a1.67 1.67 0 0 1 0-2.36l5.97-5.97" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
          )}
          {title && <h1 className="text-lg font-semibold text-text-primary">{title}</h1>}
        </div>
        <div className="p-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
